<div class="container">
	<div class="d-flex mt-3" style="transition: none;">
		<button type="button" class="icon-btn fill-whaleTail" (click)="gs.currentView = 0">
			<svg class="icon-16 fill-hover-theUpsideDown mr-1"><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
			<span class="subtitle-2 color-whaleTail backText" cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
		</button>

        <div class="ml-auto" *ngIf="(gs.canRevert && gs.selectedGame.length > 0) && selectedHistoryView === HistoryView.PlayerBreakdown">
            <form class="form-inline">
                <div class="form-row mr-2" *ngIf="enableSelection">
                    <div class="form-check mr-2">
                        <input class="form-check-input" id="gh_revertp" type="checkbox" [ngModel]="selectAll" [ngModelOptions]="{standalone: true}" (ngModelChange)="onInputChange($event)" />
                        <label class="form-check-label" for="gh_revertp" cvLocalizedText langSection="Games_History" langKey="Select_All_Players">Select all players</label>
                    </div>
                    <button type="button" class="btn btn-primary" (click)="revert()">
                        <span cvLocalizedText langSection="Games_History" langKey="Revert_Payments">Revert Payments</span>
                    </button>
                </div>
                
                <button type="button" [ngClass]="getClass()" (click)="selection()">
                    <span *ngIf="enableSelection" cvLocalizedText langSection="Games_History" langKey="Cancel_Revert_Payments"></span>
                    <span *ngIf="!enableSelection" cvLocalizedText langSection="Games_History" langKey="Revert_Payments"></span>
                </button>
            </form>
        </div>
	</div>
	<div class="content mt-3 mx-auto games-history-dropdown-container">
		<div class="col-12 d-flex px-0 pt-3" style="background-color: #f8f9fb">
			<!-- Game selector -->
			<div class="form-group col-3">
				<span class="font-size-12"><label cvLocalizedText langSection="Games_History" langKey="Game">Game</label>:</span>

				<div ngbDropdown placement="bottom-end" [autoClose]="true">
					<button ngbDropdownToggle type="button" class="form-control pr-3 pb-2">
						<div class="d-inline-block h-100 align-items-center w-100">
							<div *ngIf="gs.gamesList.length > 0" class="glGame-list-icon {{gs.selectedGame[0].iconClass}} pt-4 mr-2"></div>
							<div *ngIf="gs.gamesList.length > 0" class="text-left text-truncate pl-4 h-100 position-absolute" style="width:85%; padding-top: 2px">
                                {{gs.selectedGame[0].RuleName}}
                                <span class="color-valyrianSteel" *ngIf="!gs.selectedGame[0].isActive"> - 
                                    <span cvLocalizedText langSection="Games_History" langKey="Inactive"></span>
                                </span>
                            </div>
							<div class="text-left text-truncate h-100 pr-2" style="padding-top: 2px">
								<span *ngIf="isLoading" cvLocalizedText langSection="Games_History" langKey="Loading_Game"></span>
								<span *ngIf="!(gs.gamesList.length > 0) && !isLoading" cvLocalizedText langSection="Games_History" langKey="No_Games_Found"></span>
							</div>	
						</div>
					</button>
	
					<div ngbDropdownMenu class="dropdown-menu pb-0 w-100" aria-labelledby="simple-dropdown" [hidden]="!(gs.gamesList.length > 0)" autoClose="true" style="min-width: 313px;">
						<div class="search-box live-search px-2">
							<input type="search" class="form-control" cvLocalizedPlaceholder langSection="Common" langKey="Search" [(ngModel)]="searchGameText" (ngModelChangeDebounced)="filterGames()"/>
							<span class="clear-input" [hidden]="!(searchGameText.length > 0)" (click)="searchGameText = ''"></span>
						</div>
						<li class="dropdown-divider mb-0"></li>

						<div class="overflow-auto px-3 pt-2" style="max-height: 328px">
							<div *ngFor="let game of filteredGames$ | async">
								<li *ngIf="game.gameFolderGroup != undefined" class="body-1 pt-1 pb-2">{{game.RuleName}}</li>
								<li ngbDropdownItem class="dropdown-item cursor-pointer py-1 pl-4" *ngIf="game.underlyingRule != undefined" 
									[ngClass]="(game.underlyingRule.isSelected != undefined && game.underlyingRule.isSelected) ? 'active': ''" (click)="setSelectedGame(game)">
									<div class="d-flex flex-row py-0">
										<div class="glGame-list-icon {{game.iconClass}} mr-2"></div>
										<div>
                                            {{game.underlyingRule.RuleName}}
                                            <span class="color-valyrianSteel" *ngIf="!game.underlyingRule.isActive"> - 
                                                <span cvLocalizedText langSection="Games_History" langKey="Inactive"></span>
                                            </span>
                                        </div>
									</div>
								</li>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Interval date selector -->
			<div class="form-group col-3 gh-interval">
				<span class="font-size-12"><label cvLocalizedText langSection="Games_History" langKey="Interval">Interval</label>:</span>

				<div ngbDropdown placement="bottom-end" [autoClose]="true">
					<button ngbDropdownToggle type="button" class="form-control pr-3 pb-2 interval-btn" style="width:85%">
						<div class="d-inline-block h-100 align-items-center">
							<div class="text-left text-truncate h-100 pr-2" style="padding-top: 2px">
								<span *ngIf="gs.selectedInterval.length > 0">{{gs.selectedInterval[0].DisplayStringDate}}</span>
								<span *ngIf="isLoading" cvLocalizedText langSection="Games_History" langKey="Loading_Interval"></span>
								<span *ngIf="!(gs.selectedInterval.length > 0) && !isLoading" cvLocalizedText langSection="Games_History" langKey="None_Selected"></span>
							</div>							
						</div>
					</button>

					<div ngbDropdownMenu aria-labelledby="simple-dropdown" autoClose="true" [hidden]="gs.selectedGame.length <= 0">
						<div class="search-box live-search px-2">
							<input type="search" class="form-control" cvLocalizedPlaceholder langSection="Common" langKey="Search" [(ngModel)]="searchIntervalText" (ngModelChangeDebounced)="filterIntervals()"/>
							<span class="clear-input" [hidden]="!(searchIntervalText.length > 0)" (click)="searchIntervalText = ''"></span>
						</div>
						<li class="dropdown-divider mb-0"></li>

						<div class="px-2 pt-2" style="height:184px; overflow-y:scroll;">
							<div *ngFor="let interval of filteredIntervals$ | async">
								<li ngbDropdownItem class="dropdown-item cursor-pointer py-1 px-2" [ngClass]="(interval.isSelected != undefined && interval.isSelected) ? 'active': ''" (click)="setSelectedInterval(interval)">
									<div class="d-flex flex-row py-0">{{interval.DisplayStringDate}}</div>
								</li>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--Game History view-->
			<div class="vertical-line"></div>
			<div class="form-group col-4 gh-history">
				<span class="font-size-12 m-0"><label cvLocalizedText langSection="Games" langKey="Game_History_View">Game History view</label>:</span><br />
				<div class="m-0">
					<input type="radio" class="color-valyrianSteel" name="historyView" [value]="HistoryView.GameBreakdown" [(ngModel)]="selectedHistoryView"/>
					<label class="font-size-12 mr-2" cvLocalizedText langSection="Games" langKey="Game_Breakdown">
						 Game Breakdown
					</label>
					<input type="radio" class="color-valyrianSteel" name="historyView" [value]="HistoryView.PlayerBreakdown" [(ngModel)]="selectedHistoryView"/> 
					<label class="font-size-12"  cvLocalizedText langSection="Games" langKey="Player_Breakdown">
						Player Breakdown
					</label>
				</div>
			</div> 
			
      		<!-- Game type -->

			<div class="form-group col-3 game-type-container">
				<span class="font-size-12 m-0"><label cvLocalizedText langSection="Games" langKey="Game_Type">Game Type</label>:</span><br />
				<label class="font-size-12 color-valyrianSteel m-0" *ngIf="(!isLoading && gs.selectedGame.length > 0)">{{gs.selectedGame[0].gameTypeName}}</label>
				<label class="font-size-12 color-valyrianSteel m-0" *ngIf="(!isLoading && gs.selectedGame.length <= 0)" cvLocalizedText langSection="Games_History" langKey="No_Games_Found">No Games Found</label> 
				<label class="font-size-12 color-valyrianSteel m-0" *ngIf="isLoading" cvLocalizedText langSection="Games_History" langKey="Loading_Game">Loading Game</label>
				<svg class="icon-16 fill-valyrianSteel cursor-pointer ml-2" *ngIf="gs.selectedGame.length > 0" (click)="openGameDetail()"><use href="../../../App_Themes/clearview-default/icons/utility/support.svg#support"></use></svg>
			</div>
			<div class="form-group col-1 game-export-container">
				<div class="position-absolute export-container" ngbDropdown placement="bottom-right">
					<cv-games-history-export-button *ngIf="selectedHistoryView === HistoryView.PlayerBreakdown" [startDate]="startDate" [totalParticipants]="participantsInfoExport?.length" (click)="exportHistory()"
   					 [endDate]="endDate" [data]="exportData" [ruleID]="gs.selectedGame?.[0]?.RuleID ?? null">
					</cv-games-history-export-button>
					<cv-health-report-export-button *ngIf="selectedHistoryView === HistoryView.GameBreakdown" [startDate]="startDate" [totalParticipants]="participantsInfoExport?.length" (click)="exportGameHealthHistory()"
   					 [endDate]="endDate" [data]="exportHealthReportData" [ruleID]="gs.selectedGame?.[0]?.RuleID ?? null">
					</cv-health-report-export-button>
				</div>
			</div>
		</div>

		<div class="col-12 px-0 game-history-wrapper">
			<div class="challengesManagement" *ngIf="selectedHistoryView === HistoryView.PlayerBreakdown">
                <cv-games-history-table *ngIf="(gs.selectedGame.length > 0 && gs.selectedGame[0].GameType != 8 && !!this.hGame)" [hGame]="hGame" [participants]="participantsInfo" [enableSelection]="enableSelection" [selectAll]="selectAll" [reversion]="reversion" (selectedData)="displayModal($event)" (selectedColumns)="setColumns($event)"  (totalRow)="setTotalRow($event)" (participantsSorted)="setParticipantsSorted($event)"></cv-games-history-table>
                <cv-teams-history-table *ngIf="(gs.selectedGame.length > 0 && gs.selectedGame[0].GameType == 8 && !!this.hGame)" [hGame]="hGame" [teamsInfo]="teamsInfo" [participants]="participantsInfo" [enableSelection]="enableSelection" [selectAll]="selectAll" [reversion]="reversion" (selectedData)="displayModal($event)" (selectedColumns)="setColumns($event)" (totalRow)="setTotalRow($event)" (participantsSorted)="setParticipantsSorted($event)"></cv-teams-history-table>
			</div>
			<div class="challengesManagement" [hidden]="selectedHistoryView !== HistoryView.GameBreakdown">
                <cv-games-history-health-report [endDate]="gs.selectedInterval[0]?.EndDate" [selectedGame]="gs.selectedGame[0]" [gameActions]="gameActions" [gameRewards]="actionHistory" [participants]="participantsInfo" [intervalSelected]="gs.selectedInterval"></cv-games-history-health-report>
			</div>
			<ng-template #connect3MetricsPopover>
				<!-- Connect3/Connect All - Display Metrics -->
				<div class="row p-2" style="max-width: 220px;">
					<div class="col-4 px-2" *ngFor="let metricPosition of gs.selectedGame[0].Connect3Positions">
						<div class="card p-1 mx-n1 my-1 text-center font-size-10" 
						[ngClass]="gs.selectedGame[0].connect3Metrics[metricPosition.position].metricCompleted ? (gs.selectedGame[0].GameType == 6 ? 'cardCompleted': 'cardCompletedBlackout')  : (gs.selectedGame[0].GameType == 6 ? 'cardConfiguredConnect3': 'cardConfiguredBlackout')" style="height:60px">
							<div *ngIf="gs.selectedGame[0].connect3Metrics[metricPosition.position].metricCompleted" class="d-flex flex-row-reverse ">
								<div class="icon-12 checkMarkConnect3"></div>
							</div>
							<div class="d-flex flex-column justify-content-center align-items-center h-100">
								<div class="metric-container">
									<div *ngIf="metricPosition.metric == null">
										<svg class="icon-12 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
									</div>
									<div class="font-size-10">{{(metricPosition.metric ==  null ? getLocalizedText("Metric_Goal", "Metric Goal") : metricPosition.metric.abbrev)}}</div>
									<div *ngIf="metricPosition.targetObj.Target != null" class="font-size-10">
										{{(metricPosition.metric.direction === "0") ? "\<" : ">"}} {{getFormattedMetric(metricPosition.targetObj.Target, metricPosition.metric.conversionType)}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</div>
    </div>
</div>
